<template>
    <div class="fieldsBlock">
        <div class="fieldsBlock_title">
            <span>Description</span>
            <button type="button" class="descriptionBtn" @click="onDrawer(true)">
                <svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
            </button>
        </div>
        <div class="fieldsBlock_body">
            <div class="groupField">
                <div v-if="description.length" class="descriptionBlock-wrap">
                    <div class="descriptionBlock head">
                        <div class="descriptionBlock-item">Date created</div>
                        <div class="descriptionBlock-item">Create by</div>
                        <div class="descriptionBlock-item">Note</div>
                    </div>
                    <template v-for="({ date, created_by, msg, id }, idx) in description">
                        <div class="descriptionBlock" :key="idx">
                            <div class="descriptionBlock-item">{{ date }}</div>
                            <div class="descriptionBlock-item">{{ created_by }}</div>
                            <div class="descriptionBlock-item">{{ msg }} </div>
                            <button
                                type="button"
                                class="deleteIcon"
                                @click="onDeleteItem(idx, id)"
                            >
                                <svg-sprite height="20" width="20" icon-id="deleteItem"></svg-sprite>
                            </button>
                        </div>
                    </template>
                    <div class="descriptionBlock bottom">
                        <div class="descriptionBlock-item">n: <span>{{ description.length }}</span></div>
                        <div class="descriptionBlock-item"></div>
                        <div class="descriptionBlock-item"></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
		    <notes-drawer
				    v-if="drawer"
				    :editItem="createBy"
				    @closeDrawer="onDrawer"
				    @updateSave="onSave"
		    ></notes-drawer>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import getDefaultDate from "@/helper/getDefaultDate";
import NotesDrawer from "@/shared/Drawers/NotesDrawer/NotesDrawer.vue";

export default {
	name: "DescriptionTable",
	// components: { DescriptionPopup },
	components: { NotesDrawer },
	props: {
		createBy: String,
		description: Array
	},
	data: () => ({
		descriptionList: [],
		drawer: false
	}),
	methods: {
		...mapActions([ 'getWorkOrdersDelete' ]),
		onDrawer(value) {
			this.drawer = value;
		},
		onSave(item) {
			const values = {
				date: getDefaultDate(),
				created_by: this.createBy,
				msg: item.notes
			};
			this.$emit('updateDescriptionList', values);
			this.drawer = false;
		},
		onDeleteItem(idx, id) {
			if (id) this.getWorkOrdersDelete({ id });
			this.$emit('updateDeleteItem', idx);
		}
	}
};
</script>

<style scoped lang="scss">
@import "DescriptionTable";
</style>
